query ClientMasterTemplatesUploadConfig($clientId: ID!) {
    masterTemplateUploadConfig(clientId: $clientId) {
        filePrefix
        action
        postData
    }
}
